import React, {Component} from 'react';
import {sortArrayOfObjects} from 'helpers/common-helper';
import Const from 'constants';

class BaseUsedTeams extends Component {
    groupTeamUsage(lineups) {
        const {usedTeams} = this.props;
        const teams = {};

        Object.values(lineups).map((lineup) => {
            const teamsUsed = this.getUsedTeams(lineup);

            Object.keys(teamsUsed).map((id) => {
                let team = teamsUsed[id];
                if (team.usedLineupsCount >= Const.MLB_MIN_PLAYERS_QUANTITY_TO_IDENTIFY_USED_TEAM) {
                    if (teams.hasOwnProperty(id)) {
                        teams[id].usedLineupsCount++;
                    } else {
                        teams[id] = {usedLineupsCount: 1};
                    }
                }
            });
        });

        const teamsExposureMax = usedTeams.exposureMax.all();
        Object.keys(teamsExposureMax).map((teamName) => {
            if (!teams.hasOwnProperty(teamName)) {
                teams[teamName] = {usedLineupsCount: 0};
            }
        });

        return {...teams};
    }

    getUsedTeams(lineup) {
        const usedTeams = {};
        lineup.players.map((player) => {
            if (player.isPitcher()) {
                return;
            }

            const teamName = player.team;

            if (usedTeams.hasOwnProperty(teamName)) {
                usedTeams[teamName].usedLineupsCount++;
            } else {
                usedTeams[teamName] = {usedLineupsCount: 1};
            }
        });

        return {...usedTeams};
    }

    prepareTeams(obj) {
        let tmpArr = [];
        Object.keys(obj).map((key) => {
            let team = obj[key];
            tmpArr.push({
                name: key,
                usedLineupsCount: team.usedLineupsCount,
            });
        });
        return sortArrayOfObjects(tmpArr, 'usedLineupsCount', 'desc');
    }

    getNotFoundView() {
        return (
            <tr key="teams-not-found" className="empty">
                <td>Teams were not found.</td>
            </tr>
        );
    }

    getRowClassName(team, index) {
        const {games = {}} = this.props;

        const classNames = [];

        if (games.hasOwnProperty('isTeamGameLocked') && games.isTeamGameLocked(team.name)) {
            classNames.push('disabled-team');
        }

        if (index % 2 === 0) {
            classNames.push('even');
        }

        return classNames.join(' ');
    }
}

export {BaseUsedTeams};
